import React from 'react';
import PropTypes from 'prop-types';
import {fetchApiDataFailure} from "../../../../_actions/common.actions";

export default class ComponentDRV extends React.Component{
    static get propTypes() {
        return {
            collectionId: PropTypes.string.isRequired,
            getDRVs: PropTypes.func.isRequired
        };
    }

    constructor (props) {
        super(props);
        this.state = {
            drvs: []
        };
        this.getDRVS = this.getDRVS.bind(this);
    }

    componentDidMount() {
        this.getDRVS();
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.chapters !== this.props.chapters){
            this.getDRVS();
        }
    }

    getDRVS() {
        this.props.getDRVs(this.props.collectionId)
            .then(response => {
                this.setState({
                    drvs: response.data
                });
            })
            .catch(error => {
                fetchApiDataFailure(error);
                this.setState({
                    drvs: []
                });
            });
    }

    render() {
        return (
            <div className="drv-component-container">
                <h4>%DRV Titles</h4>
                <div className="row">
                    <div className="row header">

                        <div id="1" className="col1">ISBN</div>
                        <div id="2" className="col2">Title</div>
                        <div id="3" className="col3">Percent</div>
                        <div id="4" className="col3">Pages</div>
                        <div id="5" className="col3">Items</div>
                        <div id="6" className="col3">FM</div>
                        <div id="7" className="col3">Total Pages</div>
                    </div>
                    {(this.state.drvs && this.state.drvs.length > 0) ?
                        <div>
                            {this.state.drvs.map((drv,index) => (
                                <div className="drv-item" key={"drv"+index}>
                                    <div className="row">
                                        <div id="1" className="col1">{drv.isbn}</div>
                                        <div id="2" className="col2"><b>{drv.title}</b></div>
                                        <div id="3" className="col3">{drv.percent}%</div>
                                        <div id="4" className="col3">{drv.pageCount}</div>
                                        <div id="5" className="col3">{drv.item}</div>
                                        <div id="6" className="col3">{drv.matter}</div>
                                        <div id="7" className="col3">{drv.totalPageCount}</div>
                                    </div>
                                    <hr/>
                                </div>
                            ))}
                        </div>
                        : null}

                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/ComponentDRV.js